<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.create.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"></v-divider>
        <v-form v-model="valid" ref="form" id="valid" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <v-layout row wrap align-center justify-center>
            <v-flex xs6 sm6 md2 lg2 pl-3 pr-3>
              <v-text-field v-if="this.$store.state.configuracion.tipoDatosColumnCode[this.tableName] === 'int'" v-model="codigo" id="codigo" :label="localization.create.codigo" @keypress="isNumber($event)" maxlength="10" required />
              <v-text-field v-if="this.$store.state.configuracion.tipoDatosColumnCode[this.tableName] === 'varchar'" v-model="codigo" id="codigo" :label="localization.create.codigo" maxlength="10" required />
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field
                v-model="nombreInmuebleEspecial" id="nombreInmuebleEspecial"
                :label="localization.create.nombre"
                maxlength="100"
                required
              />
            </v-flex>
            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-checkbox
                v-if="checkMarcable"
                v-model="todasLasPromociones" id="todasLasPromociones"
                :label="localization.create.todasLasPromos"
                color="primary"
                hide-details
              />

              <v-tooltip right v-else>
                <template v-slot:activator="{ on }">
                  <v-flex v-on="on">
                    <v-checkbox
                      v-model="todasLasPromociones" id="todasLasPromociones"
                      :label="localization.create.todasLasPromos"
                      color="primary"
                      hide-details
                      :disabled="!checkMarcable"
                    />
                  </v-flex>
                </template>
                <span v-show="!checkMarcable">
                  {{localization.list.conIncidencias}}
                </span>
              </v-tooltip>
            </v-flex>
            <v-flex xs12 sm12 md1 lg1 pl-3 pr-3>
              <v-btn v-if="!inmuebleSelectedId"
                color="primary"
                :disabled="!this.codigo || !this.nombreInmuebleEspecial"
                @click="addInmueble()"
              >
                {{localization.create.addButton}}
              </v-btn>
              <v-btn v-else
                color="primary"
                :disabled="!this.codigo || !this.nombreInmuebleEspecial"
                @click="editInmueble()"
              >
                {{localization.create.editar}}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md1 lg2 pl-3 pr-3>
              <v-btn
                  color="primary"
                  :disabled="this.codigo !== null || this.nombreInmuebleEspecial !== null"
                  @click="abrirPopupImportacion()"
                >
                  {{localization.create.importar}}
                </v-btn>
            </v-flex>
          </v-layout>
        </v-form>

        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.list.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-data-table
          :headers="headers"
          :items="specialPropTypes"
          class="elevation-1"
          :loading="loading"
          
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20],
            'items-per-page-text': $t('filasPorPagina'),
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" @click="selectItem(item)" :style="{'background-color': inmuebleSelectedId === item.id ? 'lightgray' : ''}">
                <td class="text-xs-center">{{ item.code }}</td>
                <!-- <td class="text-xs-center">{{ item.name }}</td> -->
                <td class="text-xs-left">{{ item.translates[usuario.idioma] || item.name }}</td>
                <td class="text-xs-center">{{ (item.todasLasPromociones === 1 || item.todasLasPromociones === '1') ? 'Sí' : 'No' }}</td>
                <td class="text-xs-center">
                  <v-flex row justify-center>
                    <!-- <v-icon class="iconSize" small @click="openDialog(item.id)">delete</v-icon> -->
                    <v-icon class="iconSize" small @click="comprobarUsado(item.id)" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">delete</v-icon>
                    <v-icon
                        class="iconSize"
                        small
                        @click="openTranslateDialog(item.id)"
                        >mdi-web</v-icon
                      >
                  </v-flex>
                </td>
              </tr>
            </tbody>
            <ConfirmDialog @close="deleteItem()" :text="textDialog"
              @cancel="dialog = false" :dialogFlag="dialog" 
              :textoTitulo="$t('eliminar')" :textoBoton="$t('eliminar')"/>
            <TranslatePopUp
              ref="TranslatePopUp"
              :translateFlag="translateDialog"
              @cancel="translateDialog = false"
              @save="guardarTraduccion($event)"
              :idMaestro="idMaestro"
              :tipoMaestro="tipoMaestro"
            />
          </template>
        </v-data-table>
      </v-flex>
      </v-card>
      <FormImportar v-model="dialogImportar" id="dialogImportar" :tipo="tipo" @reload="cargarInmueblesEspeciales()"/>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import inputNumber from '@/mixins/inputNumber'
import FormImportar from '../formularios/formImportarGenerico'
import TranslatePopUp from "../../custom/translatePopUp.vue";

export default {
  mixins: [inputNumber],
  components: {
    ConfirmDialog,
    FormImportar,
    TranslatePopUp
  },
  data () {
    return {
      textDialog: null,
      codigo: null,
      dialog: false,
      itemToDeleteId: null,
      nombreInmuebleEspecial: null,
      loading: false,
      valid: true,
      inmuebleSelectedId: null,
      tableName: 'pv_inmueblesEspeciales',
      todasLasPromociones: false,
      dialogImportar: false,
      tipo: 'inmueblesEspeciales',
      checkMarcable: true,
      translateDialog: false,
      idMaestro: null,
      tipoMaestro: null
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
        { text: this.localization.list.nombre, value: 'name', sortable: true, align: 'left' },
        { text: this.localization.list.todasLasPromos.toUpperCase(), value: 'todasLasPromociones', sortable: true, align: 'left' },
        { text: this.localization.list.opciones, value: 'delete', sortable: false, align: 'center' }
      ]
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      console.log(this.$t('maestros.inmueblesEspeciales'))
      return this.$t('maestros.inmueblesEspeciales')
    },
    specialPropTypes () {
      if (this.$store.state.incidencias.specialPropTypes) {
        // return this.$store.state.incidencias.specialPropTypes
        return this.sortItemsByField(this.$store.state.incidencias.specialPropTypes,'name')
      }
      return []
    }
  },
  mounted () {
    this.cargarInmueblesEspeciales()

    let object = {
      'table': this.tableName,
      'column': 'codigo'
    }
    this.obtenerTipoDatosColumna(object)
      .then(() => {
        this.loading = false
      })
      .catch(e => {
        this.loading = false
        return e
      })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getSpecialPropertyTypes: 'incidencias/getSpecialPropertyTypes',
      addInmuebleEspecial: 'incidencias/addInmuebleEspecial',
      updateInmuebleEspecial: 'incidencias/updateInmuebleEspecial',
      checkUsado: 'incidencias/comprobarInmuebleEspecialAsignado',
      deleteInmuebleEspecial: 'incidencias/deleteInmuebleEspecial',
      obtenerTipoDatosColumna: 'configuracion/obtenerTipoDatosColumna',
      saveTranslates: "incidencias/updateTranslates",
    }),
    async openTranslateDialog(id) {
      
      this.tipoMaestro = "inmueblesEspeciales";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      this.loader.hide();
      this.$refs.TranslatePopUp.getTranslates()
      this.idMaestro = id;
      this.translateDialog = true;
    },
    async guardarTraduccion(traducciones) {
      let tipoMaestro = "inmueblesEspeciales";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      await this.saveTranslates({
        idMaestro: this.idMaestro,
        tipoMaestro: tipoMaestro,
        traducciones: traducciones,
      });
      await this.getSpecialPropertyTypes()
      this.loader.hide();
      this.translateDialog = true;
    },
    cargarInmueblesEspeciales() {
      this.loading = true

      this.getSpecialPropertyTypes()
      .then(() => {
        this.loading = false
      })
      .catch(e => {
        this.loading = false
        return e
      })
    },
    async comprobarUsado (id) {
      this.codigo = null
      this.nombreInmuebleEspecial = null
      this.todasLasPromociones = false
      let response = await this.checkUsado(id)
      if (response === 'KO') {

        const puedeBorrar = this.$store.state.configuracion.configuracion.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI
        if(!puedeBorrar) {
          this.addAlert({texto: this.$t('no_puede_borrar_maestros'), color: 'error'})
          return
        }
        
        this.textDialog = this.$t('estaSeguroEliminarElementoTieneSolicitudes')
      } else {
        this.textDialog = this.$t('estaSeguroEliminarElemento')
      }
      this.openDialog(id)
    },
    selectItem (item) {
      if (!this.inmuebleSelectedId || this.inmuebleSelectedId !== item.id) {
        this.inmuebleSelectedId = item.id
      } else {
        this.inmuebleSelectedId = null
      }
    },
    openDialog (itemId) {
      this.dialog = true
      this.itemToDeleteId = itemId
    },
    async deleteItem () {
      try {
        this.loading = true
        await this.deleteInmuebleEspecial(this.itemToDeleteId)
        await this.getSpecialPropertyTypes()
        this.loading = false
        this.dialog = false
        this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
      } catch (error) {
        this.loading = false
        this.dialog = false
        this.addAlert({ texto: error.message, color: 'error' })
      }
    },
    async addInmueble () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })
          const newInmuebleEspecial = {
            code: this.codigo,
            name: this.nombreInmuebleEspecial,
            todasLasPromociones: (this.todasLasPromociones) ? 'S' : 'N',
            idioma: this.usuario.idioma,
            tipoMaestro: 'inmueblesEspeciales'
          }
          await this.addInmuebleEspecial(newInmuebleEspecial)
          this.codigo = null
          this.nombreInmuebleEspecial = null
          await this.getSpecialPropertyTypes()
          this.loader.hide()
          this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: error.message, color: 'error' })
        }
      }
    },
    async editInmueble () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        try {
          const newInmuebleEspecial = {
            id: this.inmuebleSelectedId,
            code: this.codigo,
            name: this.nombreInmuebleEspecial,
            todasLasPromociones: (this.todasLasPromociones) ? 'S' : 'N',
            idioma: this.usuario.idioma,
            tipoMaestro: 'inmueblesEspeciales'
          }
          await this.updateInmuebleEspecial(newInmuebleEspecial)
          this.inmuebleSelectedId = null
          await this.getSpecialPropertyTypes()
          this.loader.hide()
          this.addAlert({texto: this.$t('edicion_correcta'), color: 'success'})
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: error.message, color: 'error' })
        }
      }
    },
    abrirPopupImportacion() {
      this.dialogImportar = true
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  },
  watch: {
    inmuebleSelectedId () {
      if (this.inmuebleSelectedId != null) {
        let inmueble = this.specialPropTypes.find(x => x.id === this.inmuebleSelectedId)
        this.codigo = inmueble ? inmueble.code : null
        this.nombreInmuebleEspecial = inmueble ? inmueble.translates[this.usuario.idioma] : null
        this.todasLasPromociones = inmueble ? ((inmueble.todasLasPromociones === 1 || inmueble.todasLasPromociones === '1') ? true : false) : null
        // si está en uso, desactivamos el check de todas las promociones
        if(inmueble.enUso) {
          this.checkMarcable = false
        } else {
          this.checkMarcable = true
        }
      } else {
        this.codigo = null
        this.nombreInmuebleEspecial = null
        this.todasLasPromociones = false
      }
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>
